import{createElement as t}from"../../../external/preact/dist/preact.js";import e from"./InputBase.js";function r(r){return t(e,{...r,type:"tel"})}export{r as default};
